import React, { useEffect, useState } from "react"
import SVG from "react-inlinesvg"
import { toAbsoluteUrl } from "../../../_metronic/_helpers"
import Paper from "@material-ui/core/Paper"
import IconButton from "@material-ui/core/IconButton"
import { Field, Form, Formik } from "formik"
import Divider from "@material-ui/core/Divider"
import { ICON_CONSTANTS } from "../../../constants/ImageConstants.js"
import clsx from "clsx"

export const Search = ({
  placeholder,
  onSubmitForm,
  initialValues,
  name,
  isActiveSearch,
  innerRef,
  type = "text",
  trigerReset,
  disabled = false,
  customClass,
  onChange,
  ...props
}) => {
  const [hasValue, setHasValue] = useState(false)
  const handleSubmit = (values) => {
    onSubmitForm(values)
  }

  useEffect(() => {
    if (isActiveSearch) {
      setHasValue(true)
    } else {
      setHasValue(false)
    }
  }, [isActiveSearch])

  const handleChange = (e) => {
    if (e.target.value.length > 0) {
      setHasValue(true)
    } else {
      setHasValue(false)
    }

    // Call onChange callback if provided
    if (onChange) {
      onChange(e.target.value)
    }
  }

  return (
    <Formik
      enableReinitialize
      innerRef={innerRef}
      onSubmit={handleSubmit}
      initialValues={initialValues}>
      {({ resetForm }) => {
        const handleReset = () => {
          resetForm()
          setHasValue(false)
          trigerReset()
        }
        return (
          <Form className={customClass}>
            <Paper className={clsx(disabled ? "search-atom_disabled" : "search-atom", customClass)}>
              {disabled ? (
                <span className={"text-neutral-white"} style={{ width: "90%" }}>
                  {placeholder}
                </span>
              ) : (
                <Field
                  className={"search-atom-input"}
                  name={name}
                  placeholder={placeholder}
                  onKeyUp={handleChange}
                  type={type}
                  {...props}
                />
              )}

              <IconButton type={"submit"} className={"search-atom-button"} aria-label="Search">
                <SVG
                  src={
                    disabled
                      ? toAbsoluteUrl(ICON_CONSTANTS.SEARCH_WHITE)
                      : toAbsoluteUrl(ICON_CONSTANTS.SEARCH)
                  }
                />
              </IconButton>
              {hasValue && (
                <>
                  <Divider className={"divider"} />
                  <IconButton
                    type={"reset"}
                    onClick={handleReset}
                    className={"clear-atom-button"}
                    aria-label="Clear">
                    <SVG src={toAbsoluteUrl(ICON_CONSTANTS.BULLET_CLOSE_RED)} />
                  </IconButton>
                </>
              )}
            </Paper>
          </Form>
        )
      }}
    </Formik>
  )
}
